module.exports = __webpack_public_path__ + "img/col1.0348645a.webp";